import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { TOKEN_ERROR } from "State/Auth/Passwords/SetPasswordsState";
import { Resources, useResource, useServerError } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { Box, Typography } from "@mui/material";

type Props = {
  errorCode: string;
};

export const SetPasswordFormErrorMessage = ({ errorCode }: Props) => {
  const { t } = useResource();
  const { translateError } = useServerError(
    Resources.SignUp.Error,
    Resources.SignUp.Error.General,
  );

  if (errorCode === TOKEN_ERROR) {
    return (
      <Box display="flex" gap={1} flexWrap="wrap">
        <ErrorText fontWeight={500}>
          {t(Resources.SetPassword.Error.TokenExpired)}
        </ErrorText>
        <Typography sx={{ textDecoration: "underline" }}>
          <UnstyledLink to={appUrl("forgottenPassword")}>
            {t(Resources.SetPassword.Error.TokenExpiredLinkText)}
          </UnstyledLink>
        </Typography>
      </Box>
    );
  }

  const translatedError = translateError(errorCode);
  if (translatedError) {
    return <ErrorText>{translatedError}</ErrorText>;
  }

  return null;
};
